export const studentConfig = {
    id: 'student',
    initial: 'draft',
    states: {
        draft: {
            on: { ACTIVATE: { target: 'active', guard: 'hasLinkedClient' } },
        },
        active: {
            on: {
                DEACTIVATE: { target: 'deactivated' },
            },
        },
        deactivated: {
            on: {
                ACTIVATE: { target: 'active', guard: 'hasLinkedClient' },
            },
        },
    },
};
//# sourceMappingURL=student.js.map